<script lang="ts">
    import MultiQuoteForm from '$components/MultiQuoteForm/MultiQuoteForm.svelte';
    import SubmitButton from '$components/Form/SubmitButton.svelte';
    import * as t from '$trans';
    import BBCode from '$components/BBCode/BBCode.svelte';
    import { getContainer } from '$components/Context/ContainerContext';
    import { cx } from '$lib/utils/cx';

    export let withCategory: boolean = true;
    export let categoryId: number | null = null;
    export let relatedCmsPostId: number | null = null;
    export let country: string | null = null;

    export let title: string | false = 'Demande de devis sans engagement';
    export let titleClass = 'mt-0 mb-10 text-gray-800 text-2xl font-bold';

    export let defaultClass: string | undefined | null =
        'bg-blue-gray-200 px-8 py-8 rounded-lg';

    let className: string | undefined | null = '';
    export { className as class };

    const { lang } = getContainer();
</script>

<div class={cx(defaultClass ?? '', className ?? '')}>
    {#if title !== false}
        <h2 class={titleClass}>
            {title}
        </h2>
    {/if}
    <MultiQuoteForm {categoryId} {relatedCmsPostId} {country} {withCategory} let:form>
        <div class="mt-8">
            <SubmitButton
                {form}
                class="btn-leo btn-leo-primary btn-lg"
                text="Envoyer votre demande"
            />
        </div>

        <p class="text-gray-600 text-13 mt-4">
            <BBCode bbcode={t.ui.form_data_processing_notice({}, $lang)} />
        </p>
    </MultiQuoteForm>
</div>
